<template>
  <div>
    <List
      url="app_upload_files/"
      :title="title"
      titleClass="title"
      :data="searchData"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealList"
      :operat="operat"
      :MultipleSel="true"
      @download="download"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right;">
          <label>APP名称：</label>
          <el-input
            v-model="searchData.app_name"
            size="small"
            style="width:200px;margin-right:10px;"
          ></el-input>

          <label>sip账号：</label>
          <el-input
            v-model="searchData.app_account"
            size="small"
            style="width:200px;margin-right:10px;"
          ></el-input>

          <label>文件名：</label>
          <el-input
            v-model="searchData.file_name"
            size="small"
            style="width:200px;margin-right:10px;"
          ></el-input>

          <label>上传类型：</label>
          <el-select
            v-model="selectUploadType"
            placeholder="上传类型"
            size="small"
            style="width:120px;margin-right:10px;">
            <el-option
              v-for="uploadType in upLoadTypeList"
              :label="uploadType"
              :key="uploadType"
              :value="uploadType"></el-option>
          </el-select>

          <el-button @click="search" type="primary" size="small"
            >搜索</el-button
          >
      </div>
    </List>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
export default {
  components: {
    List
  },
  data() {
    return {
      upLoadTypeList: ["全部", "手动上传", "自动上传"],
      selectUploadType: "手动上传",
      tanle: [
        { name: "app_name", label: "APP名称" },
        { name: "app_account", label: "sip 账号" },
        { name: "file_name", label: "文件名" },
        { name: "upload_time", label: "上传时间" },
        { name: "upload_type", label: "上传类型" }
      ],
      searchData: {
        app_name: "",
        app_account: "",
        file_name: "",
        upload_type: "0"
      },
      updateList: 0,
      title: "APP日志列表",
      operat: [
        {
          text: "Download",
          eventName: "download"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    download(val) {
      window.location.href = val.file_url;
    },
    deletedata(val) {
      let url = "app_upload_files/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    dealList(data) {
      for (let i in data) {
        data[i].upload_time = this.changeDate(data[i].upload_time);
        data[i].upload_type = this.upLoadTypeList[data[i].upload_type + 1];
      }
      return data;
    },
    search() {
      let index = this.upLoadTypeList.indexOf(this.selectUploadType) - 1;
      if (index === -1) {
          this.searchData.upload_type = '';
      } else {
          this.searchData.upload_type = index;
      }
      this.updateList++;
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  }
};
</script>
<style lang="less" scoped>
.item {
  display: flex;
  margin: 10px 0px;
  margin-right: 15px;
  line-height: 35px;
}
</style>
